import React,{useState,useEffect} from 'react';
import {Link,useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMenu,FiX}=FiIcons;

const Navbar=()=> {
  const [isOpen,setIsOpen]=useState(false);
  const [scrolled,setScrolled]=useState(false);
  const location=useLocation();

  useEffect(()=> {
    const handleScroll=()=> {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll',handleScroll);
    return ()=> window.removeEventListener('scroll',handleScroll);
  },[]);

  const navItems=[
    {path: '/',label: 'Home'},
    {path: '/chi-siamo',label: 'Chi Siamo'},
    {path: '/faq',label: 'FAQ'},
    {path: '/contatti',label: 'Contatti'}
  ];

  return (
    <motion.nav
      initial={{y: -100}}
      animate={{y: 0}}
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752009564982-photo_5999181830990974370_w.jpg"
              alt="Elvira Vigliano Logo"
              className="h-10 w-10 rounded-full"
            />
            <span className="text-2xl font-bold text-primary-600">Elvira Vigliano</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item)=> (
              <Link
                key={item.path}
                to={item.path}
                className={`font-medium transition-colors duration-200 ${
                  location.pathname===item.path
                    ? 'text-primary-600 border-b-2 border-primary-600'
                    : 'text-warm-700 hover:text-primary-600'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="md:hidden flex items-center">
            <button
              onClick={()=> setIsOpen(!isOpen)}
              className="p-2 rounded-md text-warm-700 hover:text-primary-600 transition-colors"
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>

        {isOpen && (
          <motion.div
            initial={{opacity: 0,y: -10}}
            animate={{opacity: 1,y: 0}}
            exit={{opacity: 0,y: -10}}
            className="md:hidden bg-white rounded-lg shadow-lg mt-2 py-4"
          >
            {navItems.map((item)=> (
              <Link
                key={item.path}
                to={item.path}
                onClick={()=> setIsOpen(false)}
                className={`block px-4 py-2 font-medium transition-colors duration-200 ${
                  location.pathname===item.path
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-warm-700 hover:text-primary-600 hover:bg-warm-50'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
};

export default Navbar;